import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../routes/PrivateRoute';
import PublicRoute from '../../routes/PublicRoute';
import OrganizationForm from './OrganizationForm';
import SwitchActiveOrganization from './SwitchActiveOrganization';
import AppRequestForm from './AppRequestForm';
import { Spinner } from '../Common/Spinner';
//import OrganizationsTable from './OrganizationsTable';
//import PersonalUseTable from './PersonalUseTable';
//import MemberList from './Members/MemberList';
//import OrganizationPartnershipTable from './OrganizationPartnershipTable';
const OrganizationsTable = lazy(() => import('./OrganizationsTable'));
const PersonalUseTable = lazy(() => import('./PersonalUseTable'));
const MemberList = lazy(() => import('./Members/MemberList'));
const OrganizationPartnershipTable = lazy(() => import('./OrganizationPartnershipTable'));
const MemberRankingForm = lazy(() => import('./RankingModel/MemberRankingForm'));
const OrgOnboardingList = lazy(() => import('./OrgOnboardingActions/OrgOnboardingList'));
const OrgOnboardingForm = lazy(() => import('./OrgOnboardingActions/OrgOnboardingForm'));
const MultiOrganizationReport = lazy(() => import('./Reports/MultiOrganizationReport'));
const MemberMinViewList = lazy(() => import('./Members/MemberMinViewList'));
const MCJMemberDashboard  = lazy(() => import('./Members/MCJMemberDashboard'));
const FacilityProfilePage = lazy(() => import('./MedicalCareFacility/ProfilePage/FacilityProfilePage'));

const Router = (props) => (
  <Suspense fallback={<Spinner/>}>
    <PrivateRoute path="/list/organizations" component={OrganizationsTable} searchString={props.searchString} exact />
    <PrivateRoute path="/list/personal/users" component={PersonalUseTable} searchString={props.searchString} exact />
    <PrivateRoute path="/organization/create/:id?" component={OrganizationForm} exact />
    <PrivateRoute 
      path={[
        '/:organization/members/:organization_id/:admin?', 
        '/:organization/facility/members/:organization_id/:medical_facility_id/:sub_facility_id?'
      ]} 
      component={MemberList} searchString={props.searchString} exact />
    <PrivateRoute path="/:organization/view/members/:organization_id" component={MemberMinViewList} searchString={props.searchString} exact />
    <PrivateRoute path="/list/partners" component={OrganizationPartnershipTable} searchString={props.searchString}/>
  	<Route path="/switch/organization" component={SwitchActiveOrganization} />
    <PublicRoute path="/app/request/:organization_id?" component={AppRequestForm} exact />
    <Route path="/members/ranking/model/:organization_id" component={MemberRankingForm} exact />
    <PrivateRoute path="/org/onboarding/:organization_id" component={OrgOnboardingList} searchString={props.searchString} exact />
    <PrivateRoute path="/orgs/stats" component={MultiOrganizationReport} searchString={props.searchString} exact />
    <PrivateRoute path="/mcj/member/:organization_id/:user_id/:org_member_id?" component={MCJMemberDashboard} exact />
    <PublicRoute path="/new/org/onboarding/:form_dsl_id/:form_id/:organization_id/:id?" component={OrgOnboardingForm} exact />
    <PrivateRoute path="/facility/profile/:facility_id" component={FacilityProfilePage} searchString={props.searchString} exact/>
  </Suspense>
)

export default Router;